export default __webpack_public_path__ + "static/media/loading.4eb19bfd.svg";